const trimTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

export const resolveBrowserUrl = (value) => {
  const normalizedValue = String(value || '');

  if (!normalizedValue.startsWith('/') || typeof window === 'undefined') {
    return normalizedValue;
  }

  return new URL(normalizedValue, window.location.origin).toString();
};

const defaultWebSocketUrl = () => {
  if (typeof window === 'undefined') return '';
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}`;
};

export const appConfig = {
  api: {
    baseURL: trimTrailingSlash(process.env.REACT_APP_API_URL || '/api'),
    wsURL: trimTrailingSlash(process.env.REACT_APP_WS_URL || defaultWebSocketUrl()),
    routingBaseURL: trimTrailingSlash(resolveBrowserUrl(process.env.REACT_APP_ROUTING_API_URL || '/routing/route/v1'))
  },
  services: {
    geoserverBaseURL: trimTrailingSlash(resolveBrowserUrl(process.env.REACT_APP_GEOSERVER_URL || '/geoserver')),
    floorPlanEditorURL: resolveBrowserUrl(process.env.REACT_APP_FLOOR_PLAN_EDITOR_URL || '/floor-plan-editor/')
  },
  auth: {
    accessTokenKey: 'access_token',
    refreshTokenKey: 'refresh_token'
  }
};

export const buildApiUrl = (path = '') => {
  if (!path) {
    return appConfig.api.baseURL;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${appConfig.api.baseURL}${normalizedPath}`;
};

const internalMediaHosts = new Set(['localhost', '127.0.0.1', 'minio']);

export const buildMediaUrl = (url = '') => {
  if (!url || !/^https?:\/\//i.test(url)) {
    return url;
  }

  try {
    const parsedUrl = new URL(url);

    // MinIO URLs using Docker or loopback hosts cannot be reached by a
    // browser on another machine. Send them through the React dev server.
    if (internalMediaHosts.has(parsedUrl.hostname)) {
      return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
    }
  } catch (error) {
    return url;
  }

  return url;
};

export default appConfig;
